import React, { useContext } from 'react';
import { Glyphicon, Button } from '@bingads-webui-react/primitive';
import { I18nContext } from '@bingads-webui-react/i18n-context';

function DisabledDatePicker() {
  const today = new Date();
  const fourteenDaysAgo = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate() - 13,
    today.getHours(),
    today.getMinutes()
  );
  const i18n = useContext(I18nContext);
  const formattedToday = today.toLocaleDateString();
  const formattedStartDate = fourteenDaysAgo.toLocaleDateString();
  const buttonText = `${i18n.getString(_TL_('Last 14 days: '))}${formattedStartDate} - ${formattedToday}`;

  return (
    <Button
      disabled
      style={{ paddingLeft: '8px' }}
    >{buttonText}
      <Glyphicon
        style={{ paddingLeft: '34px', paddingRight: '0px' }}
        glyph="ba-Calendar"
      />
    </Button>
  );
}

export default DisabledDatePicker;
